export const BW_GA_EVENT = 'BW_GA_EVENT'
export const BW_GTM_EVENT = 'BW_GTM_EVENT'
export const BW_MODAL_DISMISS_EVENT = 'BW_MODAL_DISMISS_EVENT'
export const BW_MODAL_CLOSE_READY_EVENT = 'BW_MODAL_CLOSE_READY_EVENT'
